import { Details } from "~/entities/Details";

export default function (stageDetail: Details): string {
  const data = {
    company: stageDetail?.company ?? "",
    address1: stageDetail.streetAddress,
    address2: stageDetail?.address2 ?? "",
    city: stageDetail.city ?? "",
    state:
      typeof stageDetail.state === "string"
        ? stageDetail.state
        : stageDetail.state?.stateprovcode ?? "",
    postalCode: stageDetail.postalCode,
    country:
      typeof stageDetail.country === "string"
        ? stageDetail.country
        : stageDetail.country?.code ?? "",
  };
  const searchParams = new URLSearchParams(data);
  return searchParams.toString();
}
